import type { App } from "vue";
import VxeUI from "vxe-pc-ui";
import VxeUITable from "vxe-table";
import zhCN from "vxe-pc-ui/lib/language/zh-CN";

import "vxe-pc-ui/lib/style.css";
import "vxe-table/lib/style.css";
/** 须在 vxe 官方 CSS 之后，覆盖默认 18px 滚动条变量与表格滚动条样式 */
import "@shared/styles/table-scrollbar.scss";

VxeUI.setI18n("zh-CN", zhCN);
VxeUI.setLanguage("zh-CN");

const ICONFONT_LOADING = "iconfont icon-loading ui-loading-icon ui-loading-icon--gradient";

VxeUI.setConfig({
    loading: { icon: ICONFONT_LOADING },
    table: {
        loadingConfig: { icon: ICONFONT_LOADING },
        headerCellConfig: { height: 40 },
        // 列宽拖拽时不展示像素宽度 tip
        resizableConfig: { showDragTip: false },
        // 默认左对齐，避免表体居中、表头被全局强制左对齐后错位
        align: "left",
        headerAlign: "left",
        footerAlign: "left",
    },
});

export function setupVxeTable(app: App) {
    app.use(VxeUI);
    app.use(VxeUITable);
}
